import React from 'react';
import SEO from '../../components/SEO/SEO';
import SubServiceTemplate from '../../components/SubServiceTemplate/SubServiceTemplate';
import onPageSeoImage from '../../images/onpage-seo.jpg';

const OnPageSEO = () => {
  const pageData = {
    category: "ON-PAGE SEO",
    title: "On-Page SEO Optimization",
    description: "Optimize every element on your website to rank higher and convert better. Our on-page SEO services ensure your content, structure, and user experience are perfectly aligned with search engine best practices.",
    heroImage: onPageSeoImage,
    ctaText: "Get a Free SEO Audit",
    ctaLink: "/contact",
    parentLink: "/services/seo",
    parentTitle: "SEO",

    features: [
      {"icon": "🔍", "title": "Keyword Research & Optimization", "description": "In-depth keyword analysis to target high-intent search terms that drive qualified traffic."},
      {"icon": "📝", "title": "Meta Tags & Titles", "description": "Compelling meta descriptions and title tags optimized for click-through rates."},
      {"icon": "🔗", "title": "Internal Linking Strategy", "description": "Strategic internal links to distribute page authority and improve site navigation."},
      {"icon": "📱", "title": "Mobile UX Enhancement", "description": "Mobile-first optimization ensuring perfect experience across all devices."},
      {"icon": "⚡", "title": "Core Web Vitals", "description": "Page speed and performance optimization for better user experience and rankings."},
      {"icon": "📊", "title": "Content Structure", "description": "H1-H6 hierarchy, schema markup, and semantic HTML for search engines."}
    ],

    benefits: [
      {
        title: "Higher Search Rankings",
        description: "Achieve top positions for your target keywords and dominate search results."
      },
      {
        title: "Increased Organic Traffic",
        description: "Drive more qualified visitors to your website without paying for ads."
      },
      {
        title: "Better User Experience",
        description: "Optimizations that benefit both search engines and your users."
      },
      {
        title: "Measurable ROI",
        description: "Track rankings, traffic, and conversions with detailed reporting."
      }
    ],

    process: [
      {
        title: "Audit & Analysis",
        description: "Comprehensive analysis of current performance and opportunities."
      },
      {
        title: "Strategy Development",
        description: "Custom roadmap tailored to your business goals and market."
      },
      {
        title: "Implementation",
        description: "Execute optimizations with precision and best practices."
      },
      {
        title: "Monitor & Refine",
        description: "Continuous tracking and optimization for maximum results."
      }
    ],

    whyChoose: {
      title: "Expert SEO Specialists",
      description: "Our team has years of experience delivering results across industries. We follow white-hat practices and stay updated with the latest algorithm changes.",
      points: [
        {
          title: "Proven Track Record",
          description: "300%+ average traffic increase for our clients"
        },
        {
          title: "Transparent Reporting",
          description: "Monthly reports with clear KPIs and actionable insights"
        },
        {
          title: "Dedicated Support",
          description: "Direct access to your SEO specialist and account manager"
        }
      ]
    },

    relatedServices: [
      {"icon": "⚙️", "title": "Technical SEO", "description": "Site performance and crawlability optimization", "link": "/services/seo/technical-seo"},
      {"icon": "🌐", "title": "Off-Page SEO", "description": "Authority building through backlinks", "link": "/services/seo/off-page"},
      {"icon": "🔗", "title": "Link Building", "description": "Strategic link acquisition campaigns", "link": "/services/seo/link-building"}
    ]
  };

  return (
    <>
      <SubServiceTemplate {...pageData} />
      
            <SEO 
                title="On Page S E O Services" 
                description="Learn more about our On Page S E O services to grow your business online with Digi Network." 
                canonical="/seo/on-page-seo" 
            />

    </>
  );
};

export default OnPageSEO;
